  <div
      class="waiting-list-btn"
      (click)="joinWaitingList(tableID, $event)"
      *ngIf="!isAlreadyWaiting(waitinglist)"
      [ngClass]="{'disabled': buttonClicked}"
  >
      <div class="waiting-list-label">JOIN WAITING LIST</div>
  </div>
  <div
      class="waiting-list-leave-btn"
      (click)="leaveWaitingList(tableID, $event)"
      *ngIf="isAlreadyWaiting(waitinglist)"
      [ngClass]="{'disabled': buttonClicked}"
  >
      <div class="waiting-list-leave-label">LEAVE WAITING LIST</div>
  </div>
  <ion-chip
      class="waiting-list-chip"
      (click)="showWaitingPlayers(tableID, $event)"
      *ngIf="waitinglist.length > 0"
  >
      <img src="/assets/icon/waiting-boy.webp" />
      <ion-label class="table-blinds">{{waitinglist.length}}</ion-label>
  </ion-chip>